import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Home, HelpCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import LyonHelpInfoModal from './LyonHelpInfoModal';

const NavigationButtons = ({ showBack = true, showHome = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();
  // 🟦 V18.1 — Modal informativo "¿Qué es Ayuda con Lyon-IA?"
  const [showLyonInfo, setShowLyonInfo] = useState(false);

  // 🟥 V18.4 — Ocultar SOLO en pantallas de autenticación los botones
  // "Home / Casita" y "¿Qué es Ayuda con Lyon IA?". Incluye login,
  // recuperación de contraseña y reset (todas las pantallas pre-auth
  // donde el usuario no está logueado todavía).
  const AUTH_ROUTES = ['/login', '/auth/login', '/forgot-password', '/reset-password', '/signup', '/auth/signup'];
  const isLoginPage = AUTH_ROUTES.includes(location.pathname);

  const t = {
    es: { back: 'Regresar', home: 'Inicio', lyonInfo: '¿Qué es Ayuda con Lyon IA?' },
    en: { back: 'Go back', home: 'Home', lyonInfo: 'What is Lyon-IA Help?' },
  };
  const txt = t[language] || t.es;

  return (
    <>
      <div className="fixed top-4 left-4 z-50 flex gap-2 items-center flex-wrap">
        {showBack && (
          <button
            data-testid="back-btn"
            onClick={() => navigate(-1)}
            className="p-2 rounded-lg bg-zinc-800/80 hover:bg-zinc-700/80 backdrop-blur-sm border border-zinc-700/50 transition-all duration-200 text-zinc-300 hover:text-white shadow-lg group"
            title={txt.back}
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-0.5 transition-transform" strokeWidth={1.5} />
          </button>
        )}
        {showHome && !isLoginPage && (
          <button
            data-testid="home-btn"
            onClick={() => navigate('/')}
            className="p-2 rounded-lg bg-indigo-600/80 hover:bg-indigo-700/80 backdrop-blur-sm border border-indigo-500/50 transition-all duration-200 text-white shadow-lg group"
            title={txt.home}
          >
            <Home className="w-5 h-5 group-hover:scale-110 transition-transform" strokeWidth={1.5} />
          </button>
        )}
        {/* 🟦 V18.1 — Botón informativo "¿Qué es Ayuda con Lyon-IA?"
            🟥 V18.4 — Oculto SOLO en la pantalla de Login. */}
        {!isLoginPage && (
          <button
            data-testid="lyon-help-info-open"
            onClick={() => setShowLyonInfo(true)}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-gradient-to-r from-fuchsia-600/80 to-indigo-600/80 hover:from-fuchsia-500/90 hover:to-indigo-500/90 backdrop-blur-sm border border-fuchsia-400/50 transition-all duration-200 text-white shadow-lg group"
            title={txt.lyonInfo}
            aria-label={txt.lyonInfo}
          >
            <HelpCircle className="w-4 h-4 group-hover:rotate-12 transition-transform" strokeWidth={1.8} />
            <span className="text-xs font-semibold whitespace-nowrap">{txt.lyonInfo}</span>
          </button>
        )}
      </div>

      <LyonHelpInfoModal
        isOpen={showLyonInfo}
        onClose={() => setShowLyonInfo(false)}
      />
    </>
  );
};

export default NavigationButtons;
